import { Button } from 'antd';
import { Download } from 'lucide-react';

interface ExportButtonProps {
  isExporting: boolean;
  error: string | null;
  onExport: () => void;
}

/** Exports the tab as .xlsx; a refusal (too many rows) is said beside the button, in words, not as a toast. */
export function ExportButton({ isExporting, error, onExport }: ExportButtonProps) {
  return (
    <div className="flex flex-col items-end gap-1">
      <Button icon={<Download className="size-4" />} loading={isExporting} onClick={onExport}>
        Export to Excel
      </Button>
      {error && (
        <p role="alert" className="max-w-xs text-right text-sm text-error">
          {error}
        </p>
      )}
    </div>
  );
}
